module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "ingress"
    }
  }, [_c('div', {
    staticClass: "col-3",
    attrs: {
      "id": "poster",
      "data-push-left": "off-2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('form', {
    staticClass: "grid-1",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('form-input', {
    staticClass: "col",
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [_c('form-label', {
    staticClass: "col-3"
  }, [_vm._v("Password")])], 1), _vm._v(" "), _c('form-input', {
    staticClass: "col",
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }, [_c('form-label', {
    staticClass: "col-3"
  }, [_vm._v("Confirm")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "form-message"
  }, [_vm._v(_vm._s(_vm.message))])])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c62147e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SetPassword.vue
// module id = 589
// module chunks = 0